/**
 @since 2021-12-03
 @author Jaeuk Ryu <wj_tams_dev02>
 */

export const state = () => ({
  AdUrl: '/api/sm/auth', // AD URL
  urlAd: '/api/sm/auth/ad', // AD URL
  urlLdap: '/api/sm/auth/ldap', // LDAP URL
  urlRadius: '/api/sm/auth/radius', // RADIUS URL
  urlTacacs: '/api/sm/auth/tacacs', // TACACS URL
  urlDbms: '/api/sm/auth/dbms', // DBMS URL
  urlSaml: '/api/sm/auth/saml-idp',
  adDataList: [], // AD 조회 리스트
  ldapDataList: [], // LDAP 조회 리스트
  radiusDataList: [], // RADIUS 조회 리스트
  tacacsDataList: [], // TACACS 조회 리스트
  dbmsDataList: [], // DBMS 조회 리스트
  samlDataList: [],

  addServerResult: 'OK', // 서버 추가시 중복 테스트 용도, 서버마지막 추가창 메인에서 작동
  selectedStoreItem: {}, // 수정중인 항목 모든탭 동일

  serverReference: { // 서버 사용 여부
    auth_profile: [],
    ip_map: [],
    ad_grp: [],
    sslvpn: [],
    saml: []
  }
  // LDAP Example
  // {
  //   "authsvr_ldap_id":1,
  //   "auth_profile":[{"auth_profile_id":1,"name": "인증 프로파일"}],
  //   "ip_map":[{"ip_map_svr_id":1,"name": "IP 매핑 프로파일"}],
  //   "ad_grp":[{"ad_grp_map_id":1,"name": "AD 그룹 매핑"}],
  //   "sslvpn":[{"sslvpn_grp_id":1,"name": "SSLVPN"}]
  // }
})

export const mutations = {
  clearStore: (state) => {
    state.addServerResult = 'OK' // 서버 마지막 추가창 메인에서 작동
  },
  // 서버 추가 동작 결과
  setSeverResult: (state, value) => { // 서버 마지막 추가창 메인에서 작동
    state.addServerResult = value
  },

  // 서버 Reference 조회
  getServerReference: (state, item) => {
    // state.serverReference = item
    const serverRef = _.clone(state.serverReference)
    const keys = Object.keys(state.serverReference)
    _.forEach(keys, key => {
      if (item[key]) {
        serverRef[key] = item[key]
      } else {
        serverRef[key] = []
      }
    })
    state.serverReference = serverRef
  },

  setSelectedStoreItem: (state, item) => {
    state.selectedStoreItem = item
  },

  // AD //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getAdDataList: (state, item) => {
    state.adDataList = item
  },
  addAdData: (state, item) => {
    state.adDataList.push(item)
  },
  edtAdData: (state, item) => {
    const idx = _.findIndex(state.adDataList, {authsvr_ad_id: item.authsvr_ad_id})
    state.adDataList.splice(idx, 1, item)
  },
  delAdDataList: (state, itemList) => {
    for (const itemKey of itemList.items) {
      const idx = _.findIndex(state.adDataList, {authsvr_ad_id: itemKey.authsvr_ad_id})
      if (idx >= 0) {
        state.adDataList.splice(idx, 1)
      }
    }
  },
  // AD //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // LDAP ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getLdapDataList: (state, item) => {
    state.ldapDataList = item
  },
  addLdapData: (state, item) => {
    state.ldapDataList.push(item)
  },
  edtLdapData: (state, item) => {
    state.ldapDataList.splice(state.selectedStoreItem.itemIndex, 1, item)
  },
  delLdapDataList: (state, itemList) => {
    for (const itemKey of itemList.items) {
      const idx = _.findIndex(state.ldapDataList, {authsvr_ldap_id: itemKey.authsvr_ldap_id})
      if (idx >= 0) {
        state.ldapDataList.splice(idx, 1)
      }
    }
  },
  // LDAP ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // RADIUS //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getRadiusDataList: (state, item) => {
    state.radiusDataList = item
  },
  addRadiusData: (state, item) => {
    state.radiusDataList.push(item)
  },
  edtRadiusData: (state, item) => {
    state.radiusDataList.splice(state.selectedStoreItem.itemIndex, 1, item)
  },
  delRadiusDataList: (state, itemList) => {
    for (const itemKey of itemList.items) {
      const idx = _.findIndex(state.radiusDataList, {authsvr_radius_id: itemKey.authsvr_radius_id})
      if (idx >= 0) {
        state.radiusDataList.splice(idx, 1)
      }
    }
  },
  // RADIUS //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // TACACS //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getTacacsDataList: (state, item) => {
    state.tacacsDataList = item
  },
  addTacacsData: (state, item) => {
    state.tacacsDataList.push(item)
  },
  edtTacacsData: (state, item) => {
    state.tacacsDataList.splice(state.selectedStoreItem.itemIndex, 1, item)
  },
  delTacacsDataList: (state, itemList) => {
    for (const itemKey of itemList.items) {
      const idx = _.findIndex(state.tacacsDataList, {authsvr_tacacs_id: itemKey.authsvr_tacacs_id})
      if (idx >= 0) {
        state.tacacsDataList.splice(idx, 1)
      }
    }
  },
  // TACACS //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // DBMS ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getDbmsDataList: (state, item) => {
    state.dbmsDataList = item
  },
  addDbmsData: (state, item) => {
    state.dbmsDataList.push(item)
  },
  edtDbmsData: (state, item) => {
    state.dbmsDataList.splice(state.selectedStoreItem.itemIndex, 1, item)
  },
  delDbmsDataList: (state, itemList) => {
    for (const itemKey of itemList.items) {
      const idx = _.findIndex(state.dbmsDataList, {authsvr_extdb_id: itemKey.authsvr_extdb_id})
      if (idx >= 0) {
        state.dbmsDataList.splice(idx, 1)
      }
    }
  },
  // DBMS ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // SAML ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getSamlDataList: (state, item) => {
    state.samlDataList = item
  },
  addSamlData: (state, item) => {
    state.samlDataList.push(item)
  },
  edtSamlData: (state, item) => {
    const index = _.findIndex(state.samlDataList, {authsvr_saml_id: item.authsvr_saml_id})
    state.samlDataList.splice(index, 1, item)
  },
  delSamlDataList: (state, itemList) => {
    for (const itemKey of itemList.items) {
      const idx = _.findIndex(state.samlDataList, {authsvr_saml_id: itemKey.authsvr_saml_id})
      if (idx >= 0) {
        state.samlDataList.splice(idx, 1)
      }
    }
  }
  // SAML ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}

export const actions = {
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.AdUrl}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // AD //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getAdDataList ({commit, state}) {
    const {code, result} = await this.$axios.$get(`${state.urlAd}/servers`)
    if (code === 'ok') {
      commit('getAdDataList', result)
      return true
    }
    return false
  },
  async addAdData ({commit, state}, item) {
    const param = _.cloneDeep(item)
    param.passwd = btoa(param.passwd)
    const {code, result} = await this.$axios.$post(`${state.urlAd}/servers`, param)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('addAdData', result)
      return true
    }
    return false
  },
  async addAdWizardData ({commit, state}, item) {
    const param = _.cloneDeep(item)
    param.passwd = btoa(param.passwd)
    const {code, result} = await this.$axios.$post(`${state.urlAd}/servers`, param, {successAlert: false})
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('addAdData', result)
      return true
    }
    return false
  },
  async edtAdData ({commit, state}, item) {
    const param = _.cloneDeep(item)
    if (param.passwd.length === 0) {
      delete param.passwd
    } else {
      param.passwd = btoa(param.passwd)
    }

    const {code, result} = await this.$axios.$put(`${state.urlAd}/servers/${param.authsvr_ad_id}`, param)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('edtAdData', result)
      return true
    }
    return false
  },
  async delAdDataList ({commit, state}, param) {
    if (param.items.length === 1) {
      const data = await this.$axios.$delete(`${state.urlAd}/servers/${param.items[0].authsvr_ad_id}`)
      if (data.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        commit('delAdDataList', param)
      }
      return data
    } else {
      const data = await this.$axios.$delete(`${state.urlAd}/servers`, {data: param})
      if (data.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        commit('delAdDataList', param)
      } else {
        if (param.items.length !== data.result.errors.length) {
          this.dispatch(`common/common/setIsChanged`, true)
        }
      }
      return data
    }
  },
  async delAdWizardDataList ({commit, state}, param) {
    const data = await this.$axios.$delete(`${state.urlAd}/servers`, {
      data: param,
      successAlert: param.hasOwnProperty('successAlert') ? param.successAlert : true
    })
    if (data.code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('delAdDataList', param)
    }
    return data
  },
  // AD //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // LDAP ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getLdapDataList ({commit, state}) {
    const {code, result} = await this.$axios.$get(`${state.urlLdap}/servers`)
    if (code === 'ok') {
      commit('getLdapDataList', result)
      return true
    }
    return false
  },
  async addLdapData ({commit, state}, item) {
    const param = _.cloneDeep(item)
    param.passwd = btoa(param.passwd)
    const {code, result} = await this.$axios.$post(`${state.urlLdap}/servers`, param)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('addLdapData', result)
      return true
    }
    return false
  },
  async edtLdapData ({commit, state}, item) {
    const param = _.cloneDeep(item)
    if (param.passwd.length === 0) {
      delete param.passwd
    } else {
      param.passwd = btoa(param.passwd)
    }

    const {code, result} = await this.$axios.$put(`${state.urlLdap}/servers/${item.authsvr_ldap_id}`, param)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('edtLdapData', result)
      return true
    }
    return false
  },
  async delLdapDataList ({commit, state}, param) {
    if (param.items.length === 1) {
      const data = await this.$axios.$delete(`${state.urlLdap}/servers/${param.items[0].authsvr_ldap_id}`)
      if (data.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        commit('delLdapDataList', param)
      }
      return data
    } else {
      const data = await this.$axios.$delete(`${state.urlLdap}/servers`, {data: param})
      if (data.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        commit('delLdapDataList', param)
      } else {
        if (param.items.length !== data.result.errors.length) {
          this.dispatch(`common/common/setIsChanged`, true)
        }
      }
      return data
    }
  },
  // LDAP ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // RADIUS //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getRadiusDataList ({commit, state}) {
    const {code, result} = await this.$axios.$get(`${state.urlRadius}/servers`)
    if (code === 'ok') {
      commit('getRadiusDataList', result)
      return true
    }
    return false
  },
  async addRadiusData ({commit, state}, item) {
    const {code, result} = await this.$axios.$post(`${state.urlRadius}/servers`, item)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('addRadiusData', result)
      return true
    }
    return false
  },
  async edtRadiusData ({commit, state}, item) {
    const {code, result} = await this.$axios.$put(`${state.urlRadius}/servers/${item.authsvr_radius_id}`, item)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('edtRadiusData', result)
      return true
    }
    return false
  },
  async delRadiusDataList ({commit, state}, param) {
    if (param.items.length === 1) {
      const data = await this.$axios.$delete(`${state.urlRadius}/servers/${param.items[0].authsvr_radius_id}`)
      if (data.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        commit('delRadiusDataList', param)
      }
      return data
    } else {
      const data = await this.$axios.$delete(`${state.urlRadius}/servers`, {data: param})
      if (data.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        commit('delRadiusDataList', param)
      } else {
        if (param.items.length !== data.result.errors.length) {
          this.dispatch(`common/common/setIsChanged`, true)
        }
      }
      return data
    }
  },
  // RADIUS //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // TACACS //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getTacacsDataList ({commit, state}) {
    const {code, result} = await this.$axios.$get(`${state.urlTacacs}/servers`)
    if (code === 'ok') {
      commit('getTacacsDataList', result)
      return true
    }
    return false
  },
  async addTacacsData ({commit, state}, item) {
    const {code, result} = await this.$axios.$post(`${state.urlTacacs}/servers`, item)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('addTacacsData', result)
      return true
    }
    return false
  },
  async edtTacacsData ({commit, state}, item) {
    const {code, result} = await this.$axios.$put(`${state.urlTacacs}/servers/${item.authsvr_tacacs_id}`, item)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('edtTacacsData', result)
      return true
    }
    return false
  },
  async delTacacsDataList ({commit, state}, param) {
    if (param.items.length === 1) {
      const data = await this.$axios.$delete(`${state.urlTacacs}/servers/${param.items[0].authsvr_tacacs_id}`)
      if (data.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        commit('delTacacsDataList', param)
      }
      return data
    } else {
      const data = await this.$axios.$delete(`${state.urlTacacs}/servers`, {data: param})
      if (data.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        commit('delTacacsDataList', param)
      } else {
        if (param.items.length !== data.result.errors.length) {
          this.dispatch(`common/common/setIsChanged`, true)
        }
      }
      return data
    }
  },
  // TACACS //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // DBMS ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getDbmsDataList ({commit, state}) {
    const {code, result} = await this.$axios.$get(`${state.urlDbms}/servers`)
    if (code === 'ok') {
      commit('getDbmsDataList', result)
      return true
    }
    return false
  },
  async addDbmsData ({commit, state}, item) {
    const param = _.cloneDeep(item)
    param.db_pw = btoa(param.db_pw)
    const {code, result} = await this.$axios.$post(`${state.urlDbms}/servers`, param)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('addDbmsData', result)
      return true
    }
    return false
  },
  async edtDbmsData ({commit, state}, item) {
    const param = _.cloneDeep(item)
    if (param.db_pw.length === 0) {
      delete param.db_pw
    } else {
      param.db_pw = btoa(param.db_pw)
    }
    const {code, result} = await this.$axios.$put(`${state.urlDbms}/servers/${item.authsvr_extdb_id}`, param)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('edtDbmsData', result)
      return true
    }
    return false
  },
  async delDbmsDataList ({commit, state}, param) {
    if (param.items.length === 1) {
      const data = await this.$axios.$delete(`${state.urlDbms}/servers/${param.items[0].authsvr_extdb_id}`)
      if (data.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        commit('delDbmsDataList', param)
      }
      return data
    } else {
      const data = await this.$axios.$delete(`${state.urlDbms}/servers`, {data: param})
      if (data.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        commit('delDbmsDataList', param)
      } else {
        if (param.items.length !== data.result.errors.length) {
          this.dispatch(`common/common/setIsChanged`, true)
        }
      }
      return data
    }
  },
  // DBMS ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // SAML ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getSamlDataList ({commit, state}) {
    const res = {code: void 0, result: void 0, cause: void 0}
    try {
      const {code, result} = await this.$axios.$get(`${state.urlSaml}/servers`)
      _.set(res, 'code', code)
      _.set(res, 'result', result)
    } catch (e) {
      _.set(res, 'code', _.get(e, ['data', 'code']))
      _.set(res, 'cause', _.get(e, ['data', 'message']))
    }

    if (res.code === 'ok') {
      commit('getSamlDataList', res.result)
      return true
    }
    return false
  },
  async addSamlData ({commit, state}, item) {
    const res = {code: void 0, result: void 0}
    const param = _.cloneDeep(item)
    try {
      const {code, result} = await this.$axios.$post(`${state.urlSaml}/servers`, param)
      _.set(res, 'code', code)
      _.set(res, 'result', result)
    } catch (e) {
      _.set(res, 'code', _.get(e, ['data', 'code']))
      _.set(res, 'cause', _.get(e, ['data', 'message']))
    }

    if (res.code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('addSamlData', res.result)
      return true
    }
    return false
  },
  async edtSamlData ({commit, state}, item) {
    const res = {code: void 0, result: void 0}
    const param = _.cloneDeep(item)
    try {
      const {code, result} = await this.$axios.$put(`${state.urlSaml}/servers/${item.authsvr_saml_id}`, param)
      _.set(res, 'code', code)
      _.set(res, 'result', result)
    } catch (e) {
      _.set(res, 'code', _.get(e, ['data', 'code']))
      _.set(res, 'cause', _.get(e, ['data', 'message']))
    }

    if (res.code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, true)
      commit('edtSamlData', res.result)
      return true
    }
    return false
  },
  async delSamlDataList ({commit, state}, param) {
    const res = {code: void 0, result: void 0}
    if (_.size(param.items) === 1) {
      try {
        const {code, result} = await this.$axios.$delete(`${state.urlSaml}/servers/${param.items[0].authsvr_saml_id}`)
        _.set(res, 'code', code)
        _.set(res, 'result', result)
      } catch (e) {
      }

      if (res.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        commit('delSamlDataList', param)
      }
      return res
    } else {
      try {
        const {code, result} = await this.$axios.$delete(`${state.urlSaml}/servers`, {data: param})
        _.set(res, 'code', code)
        _.set(res, 'result', result)
      } catch (e) {}

      if (res.code === 'ok') {
        this.dispatch(`common/common/setIsChanged`, true)
        commit('delSamlDataList', param)
      } else {
        if (_.size(param.items) !== _.size(res.result.errors)) {
          this.dispatch(`common/common/setIsChanged`, true)
        }
      }
      return res
    }
  },
  async metaDataFileUpload ({commit, state}, file) {
    const fd = new FormData()
    fd.append('file', file)
    const res = {code: '', result: {}}
    try {
      const {code, result} = await this.$axios.$post(`${state.urlSaml}/metadata`, fd, {successAlert: false, isNotShowErrorAlert: true})
      _.set(res, 'code', code)
      _.set(res, 'result', result)
    } catch (e) {
      _.set(res, 'code', _.get(e, ['data', 'code'], 'nok'))
    }
    return res
  },
  async idPAuthFileUpload ({commit, state}, file) {
    const fd = new FormData()
    fd.append('file', file)
    const res = {code: '', result: {}}
    try {
      const {code, result} = await this.$axios.$post('/api/co/gui/file/import', fd, {successAlert: false})
      _.set(res, 'code', code)
      _.set(res, 'result', result)
    } catch (e) {}

    if (res.code === 'ok') {
      return res.result.file
    }
    return ''
  },
  // SAML ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // COMMON //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  async getServerReference ({state, commit}, param) {
    let url = ''
    switch (param.type) {
      case 'adTab':
        url = state.urlAd
        break
      case 'ldapTab':
        url = state.urlLdap
        break
      case 'radiusTab':
        url = state.urlRadius
        break
      case 'tacacsTab':
        url = state.urlTacacs
        break
      case 'dbmsTab':
        url = state.urlDbms
        break
      case 'samlTab':
        url = state.urlSaml
        break
      default:
        return false
    }
    // 실패하더라도 nextTick -> dataTable.render() 를 수행해야하므로 try / catch 사용 함.
    try {
      const {code, result} = await this.$axios.$get(`${url}/servers/${param.id}/reference`)
      if (code === 'ok') {
        commit('getServerReference', result)
        return true
      }
      return false
    } catch (e) {
      return false
    }
  },
  async finalCommand ({state}, param) {
    let url = ''
    switch (param.type1) {
      case 'adTab':
        url = state.urlAd
        break
      case 'ldapTab':
        url = state.urlLdap
        break
      case 'radiusTab':
        url = state.urlRadius
        break
      case 'tacacsTab':
        url = state.urlTacacs
        break
      case 'dbmsTab':
        url = state.urlDbms
        break
      case 'samlTab':
        url = state.urlSaml
        break
      default:
        return false
    }

    let dialogOption = {}
    if (param.type2 === 'apply') {
      url += '/apply'
      dialogOption = {applyMsg: true}
    } else {
      url += '/cancel'
      dialogOption = {cancelMsg: true}
    }
    const {code} = await this.$axios.$put(url, null, dialogOption)
    if (code === 'ok') {
      this.dispatch(`common/common/setIsChanged`, false)
      return true
    }
    return false
  }
  // COMMON //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}

export const getters = {
  getTest () {
    return 1
  }
}

export const strict = false
